import { render, staticRenderFns } from "./Translations.vue?vue&type=template&id=3c289d39&scoped=true"
import script from "./Translations.vue?vue&type=script&lang=js"
export * from "./Translations.vue?vue&type=script&lang=js"
import style0 from "./Translations.vue?vue&type=style&index=0&id=3c289d39&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c289d39",
  null
  
)

export default component.exports